<template>
    <div class="stamhoofd-logo-container">
        <svg width="147" height="27" viewBox="0 0 147 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="stamhoofd-logo">
            <g clip-path="url(#clip0_12577_1236)">
                <path class="text" d="M39.2662 20.6902C36.9295 20.6902 34.848 19.9048 33.2771 18.4517L34.9462 16.4684C36.2226 17.568 37.6757 18.2357 39.384 18.2357C40.8371 18.2357 41.5833 17.568 41.5833 16.7237C41.5833 15.7615 40.7978 15.467 38.736 14.9957C35.8887 14.3477 33.8662 13.5426 33.8662 10.931C33.8662 8.43713 35.9084 6.72877 38.8538 6.72877C41.0531 6.72877 42.7615 7.41604 44.136 8.59423L42.624 10.6757C41.4262 9.7135 40.0713 9.18332 38.7753 9.18332C37.5382 9.18332 36.792 9.83132 36.792 10.6364C36.792 11.6182 37.5971 11.9324 39.6786 12.4037C42.5848 13.0517 44.5091 13.9157 44.5091 16.4095C44.5091 18.9819 42.5651 20.6902 39.2662 20.6902ZM51.0408 17.9411L51.7281 19.8066C51.139 20.3368 50.2161 20.6902 49.411 20.6902C47.6044 20.6902 46.3477 19.4139 46.3477 17.5877V12.6197H44.9535V10.3026H46.3477V7.51423H49.1164V10.3026H51.3157V12.6197H49.1164V17.136C49.1164 17.8037 49.5288 18.275 50.0786 18.275C50.4714 18.275 50.8444 18.1375 51.0408 17.9411ZM56.7889 10.067C59.4398 10.067 61.266 11.736 61.266 14.387V20.4546H58.4973V19.4335C57.7707 20.2386 56.6122 20.6902 55.4929 20.6902C53.3329 20.6902 51.6834 19.3942 51.6834 17.4502C51.6834 15.4473 53.5489 14.0728 55.8856 14.0728C56.7104 14.0728 57.6333 14.2495 58.4973 14.603V14.387C58.4973 13.307 57.81 12.3644 56.1409 12.3644C55.1984 12.3644 54.3147 12.6786 53.5096 13.091L52.5474 11.1862C53.9809 10.4597 55.3751 10.067 56.7889 10.067ZM56.1409 18.707C57.2405 18.707 58.2813 18.1964 58.4973 17.2539V16.331C57.8493 16.0757 57.0834 15.9382 56.298 15.9382C55.2573 15.9382 54.4129 16.547 54.4129 17.3717C54.4129 18.1964 55.1591 18.707 56.1409 18.707ZM75.3784 10.067C77.4991 10.067 79.1289 11.6968 79.1289 13.9942V20.435H76.3799V14.4851C76.3799 13.307 75.6337 12.4822 74.5929 12.4822C73.4344 12.4822 72.6293 13.248 72.6293 14.328V20.435H69.8606V14.4851C69.8606 13.307 69.134 12.4822 68.0737 12.4822C66.9151 12.4822 66.11 13.248 66.11 14.328V20.435H63.2431V10.3026H66.11V11.6379C66.6009 10.6757 67.622 10.067 68.8788 10.067C70.2337 10.067 71.3922 10.7346 72.0402 11.8146C72.6489 10.7346 73.8664 10.067 75.3784 10.067ZM87.182 10.067C89.4009 10.067 90.9522 11.6771 90.9522 13.9942V20.4546H88.2031V14.603C88.2031 13.3462 87.398 12.4822 86.2591 12.4822C85.0613 12.4822 84.1384 13.3462 84.1384 14.4459V20.4546H81.2715V6.72877H84.1384V11.5397C84.7667 10.6364 85.886 10.067 87.182 10.067ZM97.8757 20.6902C94.8321 20.6902 92.3382 18.2946 92.3382 15.3688C92.3382 12.443 94.8321 10.067 97.8757 10.067C100.919 10.067 103.413 12.443 103.413 15.3688C103.413 18.2946 100.919 20.6902 97.8757 20.6902ZM97.8757 18.275C99.4073 18.275 100.664 16.9593 100.664 15.3688C100.664 13.7782 99.4073 12.4822 97.8757 12.4822C96.3441 12.4822 95.0873 13.7782 95.0873 15.3688C95.0873 16.9593 96.3441 18.275 97.8757 18.275ZM109.937 20.6902C106.894 20.6902 104.4 18.2946 104.4 15.3688C104.4 12.443 106.894 10.067 109.937 10.067C112.981 10.067 115.475 12.443 115.475 15.3688C115.475 18.2946 112.981 20.6902 109.937 20.6902ZM109.937 18.275C111.469 18.275 112.726 16.9593 112.726 15.3688C112.726 13.7782 111.469 12.4822 109.937 12.4822C108.406 12.4822 107.149 13.7782 107.149 15.3688C107.149 16.9593 108.406 18.275 109.937 18.275ZM120.376 9.75277V10.3026H122.575V12.6197H120.376V20.4546H117.607V12.6197H116.213V10.3026H117.607V9.41895C117.607 7.59277 118.864 6.31641 120.67 6.31641C121.476 6.31641 122.398 6.66986 122.988 7.20004L122.3 8.94768C122.104 8.75132 121.711 8.61386 121.318 8.61386C120.788 8.61386 120.376 9.08513 120.376 9.75277ZM131.553 6.72877H134.42V20.4546H131.553V19.0211C130.748 20.0619 129.55 20.6902 128.136 20.6902C125.426 20.6902 123.482 18.491 123.482 15.3688C123.482 12.2662 125.426 10.067 128.136 10.067C129.55 10.067 130.748 10.6953 131.553 11.736V6.72877ZM128.961 18.275C130.492 18.275 131.553 17.0771 131.553 15.3688C131.553 13.68 130.492 12.4822 128.961 12.4822C127.39 12.4822 126.27 13.68 126.27 15.3688C126.27 17.0771 127.39 18.275 128.961 18.275Z" fill="#1D2129" />
                <path class="icon-fill" fill-rule="evenodd" clip-rule="evenodd" d="M11.4065 17.8551L15.2803 25.4306H6.07574L9.94955 17.8551C10.1553 17.4528 10.6482 17.2935 11.0505 17.4992C11.2036 17.5775 11.3282 17.702 11.4065 17.8551Z" fill="#0053FF" />
                <path class="icon" d="M7.81434 3.33972L19.6064 23.3863C19.8355 23.7758 19.7055 24.2772 19.316 24.5063C19.2738 24.5312 19.2294 24.5522 19.1834 24.5691C16.8777 25.4162 14.0425 25.8397 10.678 25.8397C7.3134 25.8397 4.47827 25.4162 2.17257 24.5691C1.74845 24.4132 1.53094 23.9431 1.68676 23.5189C1.70367 23.4729 1.72468 23.4285 1.74953 23.3863L14.5436 1.63635" stroke="#0053FF" stroke-width="2.45455" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_12577_1236">
                    <rect width="146.455" height="27" fill="white" />
                </clipPath>
            </defs>
        </svg>

        <svg width="26" height="34" viewBox="0 0 26 34" fill="none" xmlns="http://www.w3.org/2000/svg" class="stamhoofd-logo">
            <path class="icon-fill" fill-rule="evenodd" clip-rule="evenodd" d="M13.9412 21.823L18.6759 31.0819H7.4259L12.1606 21.823C12.412 21.3313 13.0145 21.1365 13.5062 21.388C13.6933 21.4837 13.8456 21.6359 13.9412 21.823Z" fill="#0053FF" />
            <path class="icon" d="M9.55088 4.08189L23.9634 28.5832C24.2434 29.0593 24.0845 29.6722 23.6085 29.9522C23.5569 29.9825 23.5026 30.0082 23.4463 30.0289C20.6283 31.0642 17.1631 31.5819 13.0509 31.5819C8.93862 31.5819 5.47345 31.0642 2.65537 30.0289C2.137 29.8384 1.87116 29.2638 2.06161 28.7454C2.08228 28.6891 2.10795 28.6349 2.13833 28.5832L17.7755 2" stroke="#0053FF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>
</template>

<style lang="scss">
@use '@stamhoofd/scss/base/variables' as *;

.logo-container {
    gap: 10px;
    text-decoration: none;
    align-items: center;
    display: flex;
    justify-content: flex-start;
    width: var(--block-width, 40px);
    height: var(--block-width, 40px);
}

.logo-text {
    -webkit-text-fill-color: transparent;
    text-fill-color: transparent;
    background: linear-gradient(94.7deg, #0053ff 29.42%, #7000ff 71.5%), #868686;
    -webkit-background-clip: text;
    background-clip: text;
    font-size: 16px;
    opacity: 1;
    font-style: normal;
    font-weight: $font-weight-bold;
    display: block;

    &.vertical {
        font-size: 14px;
        padding-left: 33px;
        padding-top: 5px;
    }

    &.horizontal {
        @media (max-width: 450px) {
            display: none;
        }
    }
}

.stamhoofd-logo {
    display: block;

    .text {
        fill: $color-dark;
    }

    .icon-fill {
        fill: $color-primary;
    }

    .icon {
        stroke: $color-primary;
    }

    &:last-child {
        display: none;
        width: calc(var(--block-width, 40px) - 10px);
        height: calc(var(--block-width, 40px) - 10px);
    }
}

.stamhoofd-logo-container {
    display: inline-block;  

    &.small {
        svg:first-child {
            display: none;
        }
        svg:last-child {
            display: inline-block;
        }
    }

    &.responsive {
        @media (max-width: 450px) {
            svg:first-child {
                display: none;
            }
            svg:last-child {
                display: inline-block;
            }
        }
    }
}

</style>
